import '../../assets/img/credit-card-logo.png';
import { OpenDistantSalesAggreementAction } from '../buy/distant-sales-aggreement-dialog/distant-sales-aggreement-dialog.action';
import { OpenPreInfoFormAction } from '../buy/pre-info-form-dialog/pre-info-form-dialog.action';
import { PaycellService } from '../buy/services/paycell.service';
import { MasterCard, PaymentMethod } from '../buy/services/payment-method.model';
import { ContractApproveAction } from '../common/actions/contract-approve-action';
import { Action } from '../common/actions/core/action';
import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../common/actions/core/action-handler';
import { DistantSaleAction } from '../common/actions/distant-sale-action';
import { PreInfoSaleAction } from '../common/actions/pre-info-action';
import {
  CancelSubscriptionType,
  ListeningPackageType,
  PackageThumbnail,
  UserListeningPackage
} from '../common/services/package/package.model';
import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';
import UtilService from '../common/services/util.service';
import { OpenPacketDeleteSuccessAction } from '../packet/packet-delete-success-dialog/packet-delete-success-dialog.action';
import { OpenPackageChurnRetentionSuccessAction } from '../packet/package-churn-retention-success-dialog/package-churn-retention-success-dialog.action';
import { CancelSubscriptionAction } from '../buy/cancel-subscription-dialog/cancel-subscription-dialog.action';
import { ChurnRetentionAction } from '../buy/churn-retention-dialog/churn-retention-dialog.action';
import PackageService from '../common/services/package/package.service';
import GoogleAnalyticsService from '../common/services/analytics/google-analytics.service';
import { ChangePaymentResultAction } from '../buy/change-payment-result-dialog/change-payment-result.action';
import { IPromise } from 'angular';
import { NewCreditCardEvent } from '../common/services/analytics/events/dimensions';
import { AdjustEventService } from '../buy/services/adjust-event.service';
import { OpenPacketImmediateDeleteSuccessAction } from '../packet/packet-delete-immediate-success-dialog/packet-delete-immediate-success-dialog.action';
import { BillInfoEditDialogAction } from '../buy/bill-info/edit/bill-info-edit-dialog.action';
import { Invoice } from '../buy/services/invoice.model';
import { BillInfoChangeAction } from '../buy/bill-info/bill-info.action';
import UserService from '../common/services/user/user.service';
import { UserResponse } from '../common/services/user/user.model';
import NotificationService from '../common/services/notification/notification.service';
import { BillInfoAddDialogAction } from '../buy/bill-info/add/bill-info-add-dialog.action';
import { MasterpassService } from '../buy/services/masterpass.service';
import HttpService from '../common/services/http.service';
import {ApplyChurnSuccessResponse} from "../common/services/package/package.model";

/* @ngInject */
export default class ManageSubscriptionController implements ActionHandler {
  public cards: PaymentMethod[];
  public card: PaymentMethod;
  public paymentCard: PaymentMethod;
  public payment: boolean = false;
  public invoice:Invoice;
  private packet: PackageThumbnail;
  private isCreditCardPacket: boolean;
  private isSDPPacket: boolean;
  private paycellPackageType: ListeningPackageType;
  private paymentId: string;
  private masterPaymentUid: string;
  private saleType: string;
  private showChangePayment :boolean = false;
  private user: UserResponse;
  private showInvoiceAdd:boolean;

  public masterCards: MasterCard[] = [];
  public masterCard: MasterCard;
  public creditCardType:string = '';
  private msisdnTr:string;
  private logoMap:any;
  private masterTokenRefreshCount:number = 0;


  constructor(
    private paycellService: PaycellService,
    private packageService: PackageService,
    private globalSpinner: GlobalSpinnerService,
    private actionDispatcher: ActionDispatcherService,
    private googleAnalytics: GoogleAnalyticsService,
    private adjustEventService: AdjustEventService,
    private userService: UserService,
    private notificationService: NotificationService,
    private masterpassService: MasterpassService,
    private config,
    private $rootScope,
    private $window,
    private $stateParams,
    private $translate,
    private i18n,
    private $sce,
    private httpService: HttpService
  ) {
    this.userService.getUserInfo().then(user => {
      this.user = user;
      this.msisdnTr = '90' + user.msisdn;
    });
    window['MFS'].setClientId(this.config.masterpass.clientId);
    if(!!this.config.masterpass.address) {
      window['MFS'].setAddress(this.config.masterpass.address);
    }
  }

  public $onInit() {
    this.globalSpinner.start();
    this.showInvoiceAdd = !!this.invoice ? false: true;
    if (this.packet.type === ListeningPackageType.CREDITCARD) {
      this.creditCardType = 'paycell';
      this.isCreditCardPacket = true;
      this.paycellService
        .getPaymentMethodIdByListening(this.packet.id)
        .then(id => {
          if(!!id) {
            this.paymentId = id;
            this.paycellService.getCards().then(cards => {
              this.card = UtilService.getElements(cards, data =>
                this.comparator(data)
              )[0];
              this.setChangePaymentButton();
            }).catch(error => {
              console.log('error ==> ', error);
            });
          } else{
            this.masterpassService
            .getPaymentMethodIdByListening(this.packet.id)
            .then(payment => {
              this.creditCardType = 'masterpass';
              this.paymentId = !!payment ? payment.masterpassCardName : '';
              this.masterPaymentUid = !!payment ? payment.masterpassCardUid : '';
              if(!!this.msisdnTr) {
                this.checkMasterPass();
              } else{
                this.userService.getUserInfo().then(data => {
                  this.msisdnTr = '90' + data.msisdn;
                  this.checkMasterPass();
                });
              }
            });
            this.setChangePaymentButton();
          }
        });
    } else if (this.packet.type == ListeningPackageType.SDP || this.packet.type === ListeningPackageType.MOBILODEME) {
      this.isSDPPacket = true;
      this.setChangePaymentButton();
    }

    var _self = this;

    this.$rootScope.$on("$translateChangeSuccess", function (event, a) {
      _self.packageService.getPackage().then(packages => {
        _self.packet = packages[UtilService.getElementIndexById(packages, _self.$stateParams.packetId)]
      }
      );
    });
    this.logoMap = this.config.masterpass.logoMap;
  }

  private setChangePaymentButton(){
    this.showChangePayment = this.packet.changePaymentMethod;
  }

  private changePaymentMethod() {
    const sessionId = localStorage.getItem('cardSessionId');
    const token = localStorage.getItem('cardToken');
    const alias = localStorage.getItem('cardAlias');
    const changePayment = localStorage.getItem('changePayment');
    const subscriptionId = localStorage.getItem('subscriptionId');
    const updatePaymentMethod = localStorage.getItem('updatePaymentMethod');
    const pmId = localStorage.getItem('pmId');
    const cardId = localStorage.getItem('cardId');
    localStorage.removeItem('cardSessionId');
    localStorage.removeItem('cardToken');
    localStorage.removeItem('cardAlias');
    localStorage.removeItem('changePayment');
    localStorage.removeItem('subscriptionId');
    localStorage.removeItem('updatePaymentMethod');
    localStorage.removeItem('pmId');
    localStorage.removeItem('cardId');

    if (sessionId && token) {
      this.paycellService
        .createPaymentMethod(
          sessionId,
          token,
          alias ? alias : ''
        ).then(paymentMethodId => {
          if (paymentMethodId && changePayment && subscriptionId) {
            this.paycellService.updateSubscriptionMethod(!parseInt(paymentMethodId) ? null :parseInt(paymentMethodId) , subscriptionId, paymentMethodId)
              .then((updateSubscription) => {
                this.actionDispatcher.dispatch(new ChangePaymentResultAction(!parseInt(paymentMethodId) ? null :parseInt(paymentMethodId), updateSubscription, paymentMethodId));
                this.googleAnalytics.sendPaymentChangeEvent('Success',this.packet);
                this.httpService.evictResultCache('paycellPackagePaymentMethod', true);
                this.httpService.evictResultCache('paycellPaymentMethods', true);
              }).catch((error) => { 
                this.googleAnalytics.sendPaymentChangeEvent('Failure',this.packet,error);
              }).finally(() => this.globalSpinner.stop());
              this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new NewCreditCardEvent)), { userPackage: localStorage.getItem('activePackages') }));
          } else{
            this.globalSpinner.stop();
            this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new NewCreditCardEvent)), { userPackage: localStorage.getItem('activePackages'), eventLabel: 'Failure', errorType: 'Error occured' }));
            this.googleAnalytics.sendPaymentChangeEvent('Failure',this.packet, 'Error occured');
          }
        }).catch((error) => { 
          this.globalSpinner.stop();
          this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new NewCreditCardEvent)), { userPackage: localStorage.getItem('activePackages'), eventLabel: 'Failure', errorType: error.message || 'An error occured' }));
          this.googleAnalytics.sendPaymentChangeEvent('Failure',this.packet,error);
        });
    } else if(updatePaymentMethod === '1' && sessionId && (pmId || cardId)) {
      this.findCardsByPaymentMethodId(Number(pmId), cardId).then(card => {
        this.paycellService
          .updatePaymentMethod(card.paymentMethodID, sessionId, card.cardId).then((data) => {
            this.paycellService.updateSubscriptionMethod(card.paymentMethodID, subscriptionId, card.cardId).then(updateSubscription => {
              this.actionDispatcher.dispatch(new ChangePaymentResultAction(card.paymentMethodID, updateSubscription, card.cardId));
              this.googleAnalytics.sendPaymentChangeEvent('Success',this.packet);
              this.httpService.evictResultCache('paycellPackagePaymentMethod', true);
              this.httpService.evictResultCache('paycellPaymentMethods', true);
            }).catch((error) => {
              this.globalSpinner.stop();
              this.googleAnalytics.sendPaymentChangeEvent('Failure',this.packet,error);
            })
          }).catch((error) => {
            this.globalSpinner.stop();
            this.googleAnalytics.sendPaymentChangeEvent('Failure',this.packet,error);
          })
      }).catch((error) => {
        this.globalSpinner.stop();
        this.googleAnalytics.sendPaymentChangeEvent('Failure',this.packet,error);
      })
    } else {
      this.globalSpinner.stop();
    }

  }

  public findCardsByPaymentMethodId(paymentMethodId: number, cardId: string): IPromise<PaymentMethod> {
    // similar code in payment-method.controller
    return this.paycellService.getCards().then(cards => {
      const paymentCard: PaymentMethod = cards.filter(card => card.paymentMethodID === paymentMethodId || card.cardId === cardId)[0];
      return angular.copy(paymentCard);
    });
  }

  public $postLink() {
    this.actionDispatcher.register(this);
    this.changePaymentMethod();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
  }

  public handle(action: Action) {
    if (action instanceof DistantSaleAction) {
      this.saleType = action.type;
      this.openDistantSale();
    }

    if (action instanceof PreInfoSaleAction) {
      this.openPreInfo();
    }

    if (action instanceof BillInfoChangeAction) {
      this.invoice = action.invoice;
      this.showInvoiceAdd = !!this.invoice ? false: true;
    }


  }

  public onManageSubscription() {
    if (this.showChangePayment) {
      this.payment = true;
    }
  }

  public onDelete(packet: PackageThumbnail) {
    if (this.enableCancelPackage()) {
      this.globalSpinner.start();
      this.paycellService.checkOfferBeforeChurn(packet.id).then(response => {
        this.globalSpinner.stop();
        const masterCardName = this.creditCardType === 'masterpass' ? this.paymentId : undefined;
        if(response && response.discountRate) {
            this.actionDispatcher.dispatch(new ChurnRetentionAction((type: CancelSubscriptionType) => {
              this.onDeleteSuccess(type);
            }, (message:ApplyChurnSuccessResponse) => {
             this.onChurnSuccess(message);
            }, packet, response.price, response.discountRate, response.discountedPrice, response.discountedRenewalCount, this.msisdnTr, masterCardName));
        } else{
          this.actionDispatcher.dispatch(new CancelSubscriptionAction((type:CancelSubscriptionType) => this.onDeleteSuccess(type), packet, this.msisdnTr, masterCardName));
        }
      }).catch(error => {
        this.globalSpinner.stop();
        const masterCardName = this.creditCardType === 'masterpass' ? this.paymentId : undefined;
        this.actionDispatcher.dispatch(new CancelSubscriptionAction((type:CancelSubscriptionType) => this.onDeleteSuccess(type), packet, this.msisdnTr, masterCardName));
      });
    }
  }

  private onChurnSuccess(messageObj: ApplyChurnSuccessResponse): void {
    this.actionDispatcher.dispatch(new OpenPackageChurnRetentionSuccessAction(messageObj));
  }

  private onDeleteSuccess(type: CancelSubscriptionType): void {
    this.googleAnalytics.sendCancelPackage('Success',this.packet);
    this.adjustEventService.postEvent('qck8tr', this.packet.priceUnit, this.packet.price);
    if(type == CancelSubscriptionType.COMMITMENT) {
      this.packageService.getUserListeningPackages().then(listeningPackages => {
        const ulps: UserListeningPackage[] = listeningPackages.userListeningPackages;
        ulps.forEach(ulp => {
          if(ulp.listeningPackage.offerId == this.packet.id){
            this.packet.nextRenewalDate = ulp.nextRenewalDate;
          }
        });
      }).finally(() =>{
        if(this.packet.nextRenewalDate){
          this.$translate('dialog.packet.delete.success.messageDetail', this.packet.nextRenewalDate).then(value => {
            this.actionDispatcher.dispatch(new OpenPacketDeleteSuccessAction(value));
          });
        } else{
          this.$translate('dialog.packet.delete.success.message').then(value => {
            this.actionDispatcher.dispatch(new OpenPacketDeleteSuccessAction(value));
          });
        }
      });
    } else{
      this.actionDispatcher.dispatch(new OpenPacketImmediateDeleteSuccessAction());
    }
  }




  private openDistantSale() {
    this.actionDispatcher.dispatch(
      new OpenDistantSalesAggreementAction(
        () => this.approveDistantSale(),
        this.saleType,
        this.packet.id
      )
    );
  }

  private approveDistantSale() {
    this.actionDispatcher.dispatch(
      new ContractApproveAction({
        distantAggreement: true
      })
    );
  }

  private approvePreInfo() {
    this.actionDispatcher.dispatch(
      new ContractApproveAction({
        preInfoAggreement: true
      })
    );
  }

  private openPreInfo() {
    this.actionDispatcher.dispatch(
      new OpenPreInfoFormAction(() => this.approvePreInfo(), this.packet.id)
    );
  }

  private comparator(element: any): boolean {
    return element.paymentMethodID == this.paymentId || element.cardId == this.paymentId;
  }

  public enableCancelPackage() {
    if (this.packet.manageSubscription) {
      return true;
    }

    if (!this.packet.cancelReqSent && !(this.packet.type === ListeningPackageType.CREDITCARD && !this.card && !this.masterCard)) {
      return true;
    }
    return false;
  }

  public getIcon() {
    return this.packageService.getPackageIcon(this.packet);
  }

  public onEdit() {
    // this.$state.go('billInfoEdit');
    this.actionDispatcher.dispatch(new BillInfoEditDialogAction(this.invoice));
  }

  public checkMasterPass(){
    this.masterpassService.isV2().then(isV2 => {
      if (isV2) {
        this.checkMasterPassV2();
        return;
      }

      this.checkMasterPassV1();
    });
  }

  private checkMasterPassV1(){
    $('[name=referenceNo]').val(UtilService.generateRandomNumber(999999999999));
    $('[name=userId]').val(this.msisdnTr);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if(!!masterToken) {
        $('[name=token]').val(masterToken);
        window['MFS'].checkMasterPass($('#checkMP-form'), this.chkMPResponseHandler.bind(this));
    } else {
      this.masterpassService.getToken().then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].checkMasterPass($('#checkMP-form'), this.chkMPResponseHandler.bind(this));
      });
    }
  }

  private chkMPResponseHandler(status, response) {
		if (response.responseCode == "0000" || response.responseCode == "") {
      if (response.accountStatus.indexOf("011100") == 0){
        this.listMasterCards();
      }
		} else if(this.config.masterpass.tokenRefreshErrorCodes.indexOf(response.responseCode) >= 0 && this.masterTokenRefreshCount < 5){
      sessionStorage.removeItem("masterpass.token");
      this.checkMasterPass();
      this.masterTokenRefreshCount++;
    } else {
			console.log(response.responseDescription);
		}
	}

  private checkMasterPassV2() {
    this.masterpassService.accountAccess(this.msisdnTr)
      .then(response => this.accountAccessResponseHandler(response))
      .catch(error => this.accountAccessResponseHandler(error));
  }

  private accountAccessResponseHandler(response: any) {
    const exceptionCode = response && response.exception ? response.exception.code : null;
    if (exceptionCode === 'ACCOUNT_NOT_FOUND' || exceptionCode === 'ACCOUNT_NOT_LINKED_TO_MERCHANT') {
      this.globalSpinner.stop();
      return;
    }

    if (response && response.result) {
      this.listCardsResponseHandler(null, {
        responseCode: '',
        cards: this.masterpassService.toV1MasterpassCards(response.result.cards)
      });
      return;
    }

    console.log(response && response.exception ? response.exception.message : null);
    this.globalSpinner.stop();
  }
  public listMasterCards(){
    this.masterpassService.isV2().then(isV2 => {
      if (isV2) {
        this.listMasterCardsV2();
        return;
      }

      this.listMasterCardsV1();
    });
  }

  private listMasterCardsV1(){
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if(!!masterToken) {
        window['MFS'].listCards(this.msisdnTr, masterToken, this.listCardsResponseHandler.bind(this));
    } else {
      this.masterpassService.getToken().then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        window['MFS'].listCards(this.msisdnTr, token, this.listCardsResponseHandler.bind(this));
      }).finally(() => this.globalSpinner.stop());
    }
  }

  private listMasterCardsV2() {
    this.masterpassService.accountAccess(this.msisdnTr)
      .then(response => this.accountAccessResponseHandler(response))
      .catch(error => this.accountAccessResponseHandler(error));
  }

  private listCardsResponseHandler(statusCode, response)
	{
		if (response.responseCode != "0000" && response.responseCode != "") {
			console.log(response.responseDescription);
			return;
		}

		this.masterCards =  response.cards;
    this.masterCard = UtilService.getElements(this.masterCards, data =>{
      if(!!this.masterPaymentUid){
        return data.UniqueId == this.masterPaymentUid;
      } else{
        return data.Name == this.paymentId;
      }
    }
    )[0];
    this.globalSpinner.stop();
	}

  public getMasterPassCardLogoonError(){
    if(!!this.masterCard) {
      return this.masterCard.Value1.startsWith('4') ? '/assets/img/visa@2x.png' : (this.masterCard.Value1.startsWith('5') ? '/assets/img/credit-card-logo.png' : '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-subscription/manage-subscription.controller.ts